import { AFNewUserListPage, AFNewUserEditPage, AFNewUserCreatePage } from './imports';

export const newUserRoutes = [
  {
    path: 'new-user',
    children: [
      { element: <AFNewUserListPage />, index: true },
      { path: 'list', element: <AFNewUserListPage /> },
      { path: ':id/edit', element: <AFNewUserEditPage /> },
      { path: 'new', element: <AFNewUserCreatePage /> },
    ],
  },
];
